import confetti from 'canvas-confetti';

const DEFAULTS = {
  spread: 70,
  ticks: 100,
  gravity: 1.2,
  decay: 0.94,
  startVelocity: 30,
  colors: ['#f472b6', '#a78bfa', '#34d399', '#fbbf24', '#60a5fa'],
};

export const useCelebration = () => {
  const celebrate = (options = {}) => {
    const count = options.count || 150;
    const origin = options.origin || { x: 0.5, y: 0.6 };

    // Fire from left
    confetti({
      ...DEFAULTS,
      particleCount: Math.floor(count / 3),
      origin: { x: origin.x - 0.15, y: origin.y },
      ...options,
    });

    // Fire from center
    confetti({
      ...DEFAULTS,
      particleCount: Math.floor(count / 3),
      origin,
      ...options,
    });

    // Fire from right
    confetti({
      ...DEFAULTS,
      particleCount: Math.floor(count / 3),
      origin: { x: origin.x + 0.15, y: origin.y },
      ...options,
    });
  };

  return { celebrate };
};
